import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {getImagePathWithTheme, getLocalFilePath} from "../../utils";
import {Dropdown, message, Modal} from "antd";
import {pauseAllVideo} from "../../Utility";
import CustomAudio from "../../../@excalidraw/packages/excalidraw/components/Audio/CustomAudio";
import {FROM_DIALOG, MAX_Z_INDEX} from "../../Const";

const DialogAddToLibrary = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
    }))
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [data,setData] = useState(null);
    const mCallback = useRef<any>(null);

    const onShowDialog = (libraryData:any,callback:any,szTipMessage:any)=>{
        setIsShowDialog(true);
        setData(libraryData)
        mCallback.current = callback;

        // setTimeout(()=>{
        //     if (szTipMessage){
        //         message.info(szTipMessage);
        //     }
        // },300)
    }

    const getTitle = ()=>{
        if (data?.type == 'image'){
            return t("ImageAddedToLibrary");
        }else if (data?.type == 'video'){
            return t("VideoAddedToLibrary")
        }
        return '';
    }

    const getButtonText = ()=>{
        if (data?.type == 'image'){
            return t("LinkToImage");
        }else if (data?.type == 'video'){
            return t("LinkToVideo")
        }
        return '';
    }
    return(
        <Modal width={521} zIndex={MAX_Z_INDEX} bodyStyle={{height:`${441}px`}}
               open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null} onCancel={()=> {
            setIsShowDialog(false);
            props.onCloseCallback();
        }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title'}>{getTitle()}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <div className={'mt-0 flex-center'} style={{width: '100%', flexGrow: '1', overflow: 'hidden'}}>
                    {
                        data?.type == 'image' &&
                        <img style={{maxWidth: '100%', maxHeight: '100%'}}
                             src={getLocalFilePath(data.fileName, data.isAbsolutePath)}/>
                    }

                    {
                        data?.type == 'video' &&
                        <video onPlay={(event) => {
                            pauseAllVideo(event.target);
                        }} style={{background: 'black', objectFit: 'contain', width: '100%', height: '100%'}} controls
                               src={getLocalFilePath(data.fileName, data.isAbsolutePath)}/>
                    }

                    {
                        // data?.type == 'audio' &&
                        // <div style={{width:'100%',height:'100px'}}>
                        //     <CustomAudio ref={customAudioRef} szUrl={getLocalFilePath(data.fileName,data.isAbsolutePath)} from={FROM_DIALOG}/>
                        // </div>
                    }

                </div>

                <div className={'flex-center mt-16'}>
                    <span className={'button-solid-style flex-center'} onClick={()=>{
                        if (mCallback.current) {
                            mCallback.current(data);
                            if (props.onCloseCallback) {
                                props.onCloseCallback();
                            }
                        }
                    }}
                          style={{minWidth: '188px', height: '36px', padding: '0 16px'}}>
                        {getButtonText()}
                    </span>
                </div>
            </div>
        </Modal>
    )
})

export default DialogAddToLibrary;

























